import { routerActivityLog } from '@view/ActivityLog/router';
import { routerAdminAccount } from '@view/AdminAccount/router';
import {
  routerApplications,
  routerApplicationsAdd,
  routerApplicationsEdit,
  routerApplicationsInfo,
  routerApplicationsSort,
} from '@view/Applications/router';
import { routerForgotPassword } from '@view/Auth/ForgotPassword/router';
import { routerLogin } from '@view/Auth/Login/router';
import { routerVerificationInfo, routerViewProfile } from '@view/Auth/Profiles/router';
import { routerResetPassword } from '@view/Auth/ResetPassword/router';
import { routerDocuments } from '@view/Documents/router';
import { routerHome } from '@view/Home/router';
import { routerHomeNormal } from '@view/HomeNormal/router';
import { routerListApplication } from '@view/ListApplication/router';
import { routerPageError } from '@view/PageError/router';
import { routerSystemAccount } from '@view/SystemAccount/router';
import {
  routerUserGroup,
  routerUserGroupAdd,
  routerUserGroupEdit,
  routerUserGroupInfo,
} from '@view/UserGroup/router';

import { IRouter } from './interface';

export const privatePageNormal: IRouter[] = [
  routerDocuments,
  routerHomeNormal,
  routerListApplication,
  routerViewProfile,
  routerVerificationInfo,
  routerPageError,
];

export const privatePageSystem: IRouter[] = [
  routerHome,
  routerApplications,
  routerApplicationsInfo,
  routerApplicationsAdd,
  routerApplicationsEdit,
  routerApplicationsSort,
  routerAdminAccount,
  routerSystemAccount,
  routerUserGroup,
  routerUserGroupAdd,
  routerUserGroupEdit,
  routerUserGroupInfo,
  routerActivityLog,
  routerViewProfile,
  routerVerificationInfo,
  routerPageError,
];

export const publicPage: IRouter[] = [
  routerForgotPassword,
  routerResetPassword,
  routerLogin,
  routerPageError,
];
